import { Building2, Home, Router, User, type LucideIcon } from "lucide-react";

export interface NavItem {
  labelKey: string;
  to: string;
  icon: LucideIcon;
}

export const navItems: NavItem[] = [
  { labelKey: "nav.home", to: "/", icon: Home },
  { labelKey: "nav.users", to: "/user", icon: User },
  { labelKey: "nav.devices", to: "/device", icon: Router },
  { labelKey: "nav.deviceBrands", to: "/device/brand", icon: Router },
  { labelKey: "nav.organisations", to: "/organisation", icon: Building2 },
  { labelKey: "nav.lnsManagement", to: "/lns", icon: Router },
];
